import { INBOX_FILTERS_KEY } from './hooks/use-conversation-status-mutation.js';
/** Тот же контроль формы, что у `readInboxFilters` в `inbox-page.tsx`. */
const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
/**
 * Предустановка фильтров инбокса ПЕРЕД переходом на `/conversations` из
 * другого раздела (ссылка «показать диалоги» на странице тегов).
 *
 * Инбокс читает фильтры не из адреса, а из `localStorage` (`INBOX_FILTERS_KEY`,
 * ленивый инициализатор `useState(readInboxFilters)` в `inbox-page.tsx`):
 * маршруты модулей заводятся шеллом одинаково, без `validateSearch`, поэтому
 * параметра `?tag=` у страницы нет и завести его «только для одного ключа»
 * значило бы протянуть поисковую схему через тип модуля и фабрику маршрутов.
 * Запись в то же хранилище — единственный вход, который инбокс уже умеет
 * читать; форму он валидирует сам при чтении, так что здесь достаточно
 * записать валидный объект.
 *
 * Прежние фильтры НЕ сливаются, а заменяются: ссылка на тег — это новый
 * вопрос («какие диалоги с этим тегом?»), а не уточнение прошлого визита.
 * Оставшийся поиск или статус `open` молча сузили бы ответ, и число в инбоксе
 * разошлось бы с числом «Диалогов» на странице тегов, которое считает по всем
 * статусам.
 *
 * Best-effort: недоступное хранилище (приватный режим, квота) не ломает
 * переход — инбокс просто откроется со своими умолчаниями.
 */
export function presetInboxFilters(preset) {
    const next = {};
    const tagIds = (preset.tagIds ?? []).filter((id) => UUID_RE.test(id));
    if (tagIds.length > 0)
        next.tagIds = tagIds;
    try {
        localStorage.setItem(INBOX_FILTERS_KEY, JSON.stringify(next));
    }
    catch {
        /* best-effort persistence */
    }
}
//# sourceMappingURL=inbox-filters-preset.js.map